import {
  Sheet,
  SheetContentResizable,
  SheetFooter,
  SheetHeader,
  SheetTitle,
} from '@/components/ui/sheet';
import { Button } from '@/components/ui/button';
import { useLocalStorageValue } from '@react-hookz/web';
import { T } from 'gt-react';
import {
  EntityDetailTabsProvider,
  EntityDetailTabsHeader,
  EntityDetailTabsContent,
  useEntityDetailTabsContext,
} from '@/components/system-entities/entity-detail-tabs';
import { SystemEntity } from '@erp/shared-types';
import { Tabs } from '@/components/ui/tabs';

function PurchaseOrderDetailTabsWrapper() {
  const { activeTabId, setActiveTabId } = useEntityDetailTabsContext();
  return (
    <Tabs
      value={activeTabId}
      onValueChange={setActiveTabId}
      className="flex flex-col flex-1 min-h-0"
    >
      <SheetHeader className="shrink-0 grow-0 border-b px-3 py-3">
        <EntityDetailTabsHeader />
      </SheetHeader>
      <div className="flex-1 min-h-0 overflow-hidden">
        <EntityDetailTabsContent />
      </div>
    </Tabs>
  );
}

export function PurchaseOrderDetailSlidein({
  isOpen,
  onOpenChange,
  purchaseOrderId,
}: {
  isOpen: boolean;
  onOpenChange: (open: boolean) => void;
  purchaseOrderId?: string;
}) {
  const { value: detailViewSize, set: setDetailViewSize } =
    useLocalStorageValue<number>('purchase-order-detail-view-size', {
      defaultValue: 50,
    });

  return (
    <Sheet open={isOpen} onOpenChange={onOpenChange}>
      <SheetContentResizable
        hideCloseButton
        resizableProps={{
          defaultSize: detailViewSize,
          onResize: setDetailViewSize,
          className: 'flex flex-col',
        }}
      >
        {purchaseOrderId ? (
          <EntityDetailTabsProvider
            initialEntity={{
              entityType: SystemEntity.INTERNAL_PURCHASE_ORDER,
              entityId: purchaseOrderId,
            }}
          >
            <PurchaseOrderDetailTabsWrapper />
          </EntityDetailTabsProvider>
        ) : (
          <>
            <SheetHeader className="shrink-0 grow-0">
              <SheetTitle>
                <T context="title for the purchase order detail slide-in panel">
                  Purchase Order Details
                </T>
              </SheetTitle>
            </SheetHeader>
            <div className="p-4 text-sm text-muted-foreground">
              <T context="placeholder text shown when no purchase order is selected in the purchase order detail panel">
                No purchase order selected
              </T>
            </div>
          </>
        )}
        <SheetFooter className="shrink-0 grow-0 flex items-end border-t">
          <Button
            onClick={() => {
              onOpenChange(false);
            }}
            className="w-fit"
          >
            <T context="button label to close the purchase order detail panel">
              Close
            </T>
          </Button>
        </SheetFooter>
      </SheetContentResizable>
    </Sheet>
  );
}
